export type CurrentTier = 'degustacao' | 'one' | 'ultimate' | 'black' | 'grandfathered';

const TIER_BY_GATEWAY_ID: Record<string, CurrentTier> = {
  '7022850': 'degustacao',
  '7022851': 'one',
  '7022859': 'ultimate',
  '7022862': 'black',
};

export const resolveCurrentTier = (gatewayId?: string | number | null): CurrentTier => {
  if (gatewayId == null) return 'grandfathered';

  return TIER_BY_GATEWAY_ID[String(gatewayId)] ?? 'grandfathered';
};
